import React, { useState, useMemo, useEffect } from 'react';
import { toast } from 'react-toastify';

import SelectInterface from './SelectInterface.js';
import MapTableEditForm from './MapTableEditForm.js';
import {callback} from '../../helpers.js';
import api from '../../api/index.js';

export default (props) => {
	const [value, setValue] = useState(props.value || false);
	const [data, setData] = useState(false);
	const [parentdata, setParentdata] = useState(false);
	const [firstDataRetrievalStarted, setFirstDataRetrievalStarted] = useState(false);


	useEffect(()=> {
		if (firstDataRetrievalStarted === false)
			refresh();
	});


	useMemo(()=>{
		console.log("re-memoing");
		setValue(props.value || false);
	}, [props.value]);

	const refresh = async () => {
		setFirstDataRetrievalStarted(true)
		try {
			let data = await api.get('maptable/' + props.maptable);
			
			let pdata = {};
			// Retrieve the parent data
			if (props.hasOwnProperty('parents')) {
				for(let i=0; i < props.parents.length; i++) {
					let p = await api.get('maptable/' + props.parents[i]);
					pdata[props.parents[i]] = p;
				}
			}
			
			// Group
			if (props.hasOwnProperty('groupby') && pdata.hasOwnProperty(props.groupby)) {
				let map = {};
				for(let i=0; i < pdata[props.groupby].length; i++) {
					map[pdata[props.groupby][i].ID] = pdata[props.groupby][i].Name;
				}
				for(let i=0; i < data.length; i++) {
					data[i]['group'] = map[data[i][props.groupby + 'ID']];
				}
			}
			setData(data);
			setParentdata(pdata);
		} catch(e) {
			api.handleExceptions(e);
		};
	}

	const onChange = (e) => {
		console.log("onChange", e);
		setValue(e);
		callback(props.onChange, [{
					target: {
						name: props.name,
						value: e
					}
		}]);
	}



	const onEditSubmit = async (e, p) => {
		try {
			await api.put('maptable/' + props.maptable + '/' + e.value, {Name: p.name});
			refresh();
			toast.success(props.maptable + " updated.");
			return true;
		} catch(e) {
			api.handleExceptions(e);
		};
			
		return false;
	}


	const onAddSubmit = async (e, p) => {
		try {
			let obj = {...p};
			obj['Name'] = p.name;
			delete obj['name']; 
			
			// for(var k in this.props)
				// if (['maptable', 'value', 'name', 'placeholder', 'onChange'].indexOf(k) === -1)
					// obj[k] = this.props[k];
				
			await api.post('maptable/' + props.maptable, obj);
			refresh();
			toast.success(props.maptable + " added.");
			return true;
		} catch(e) {
			api.handleExceptions(e);
		};
			
		return false;
	}


	
	let list = [];
	
	let _data = data || [];
	let pdata = parentdata || [];
	
	let v = value;
	// Either group the options or don't
	if (props.hasOwnProperty('groupby') && pdata.hasOwnProperty(props.groupby)) {
		for(let i=0; i < pdata[props.groupby].length; i++) {
			let o = {
				label: pdata[props.groupby][i].Name,
				options: []
			};
			for(let t=0; t < _data.length; t++) {
				if (_data[t][props.groupby + 'ID'] === pdata[props.groupby][i].ID) {
					o.options.push({
						value: _data[t].ID,
						label: _data[t].Name,
						group: _data[t].group
					});
					if (typeof value !== 'object' && value === _data[t].ID) // The value comes back as an ID sometimes.  If it is, replace it with our obj matching that id.
						v = o.options[o.options.length-1]
				}
			}
			list.push(o);
		}
	} else {
		for(let i=0; i < _data.length; i++) {
			let o = {
				value: _data[i].ID,
				label: _data[i].Name
			};
			list.push(o);
			if (typeof value !== 'object' && parseInt(value) === _data[i].ID) // The value comes back as an ID sometimes.  If it is, replace it with our obj matching that id.
				v = o
		}
	}

	return <div>
		<SelectInterface 
			placeholder={props.placeholder}
			onEditSubmit={onEditSubmit}
			onAddSubmit={onAddSubmit}
			value={v}
			options={list}
			type={props.maptable}
			name={props.name}
			onChange={onChange}
			editForm={props.editForm || MapTableEditForm}
			addForm={props.addForm || MapTableEditForm}
			addParams={{parents: props.parents}}
		/>
	</div>;

}

